export const desciptionToolbarColors = [
  "black",
  "white",
  "red",
  "green",
  "blue",
  "yellow",
  "purple",

  "#371E30",
  "#A03E99",
  "#DF57BC",
  "#F59CA9",

  "#FF004F",
  "#FF7F7F",
  "#ED2939",
  "#FFE4E1",

  "#990000",
  "#FF0800",
  "#E60026",
  "#65000B",

  "#FF2400",
  "#FF4F00",
  "#E34234",
  "#FF6347",

  "#FFBF00",
  "#ED9121",
  "#FF8C00",
  "#FFD700",

  "#3B3C36",
  "#9F8170",
  "#EFDECD",
  "#F5F5DC",

  "#B2BEB5",
  "#8B8589",
  "#808080",
  "#696969",

  "#7B3F00",
  "#6F4E37",
  "#B87333",
  "#81613E",

  "#808000",
  "#CFB53B",
  "#D1E231",
  "#E3F988",

  "#1E4D2B",
  "#00563B",
  "#00FFFF",
  "#ACE1AF",

  "#004953",
  "#317873",
  "#3EB489",
  "#00A693",

  "#007FFF",
  "#7DF9FF",
  "#0000FF",
  "#003262",

  "#0047AB",
  "#1F305E",
  "#16166B",
  "#002147",

  "#f0db4f",
  "#007acc",
  "#41b883",
  "#35495e",

  "#61dafb",
  "#a6120d",
  "#dd1b16",
  "#00A912",

  "#764abc",
  "#f9dc3e",
  "#323330",
  "#e44d26",

  "#361d32",
  "#543c52",
  "#edd2cb",
  "#f1e8e6",

  "#454d66",
  "#309975",
  "#58b368",
  "#dad873",

  "#efeeb4",
  "#272643",
  "#e3f6f5",
  "#bae8e8",

  "#12492f",
  "#0a2f35",
  "#f56038",
  "#ffca7a",

  "#553772",
  "#8f3b76",
  "#c7417b",
  "#f5487f",

  "#f6d912",
  "#C0C0C0",
  "#301551",
  "#1ac0c6",

  "#fdfa66",
  "#fb7756",
  "#e74645",
  "#facd60",

  "#ef233c",
  "#778da9",
  "#344e41",
  "#fca311",

  "#d8e2dc",
  "#00afb9",
  "#900020",
  "#4B443C",

  "#575758",
  "#b2ff00",
]

export const bookmarkColors = [
  "#222b00",
  "#849448",
  "#fff48c",
  "#ed9b1f",
  "#960000",
  "#ff9276",
  "#c7ffcd",
  "#462eff",
  "#170f55",
  "#005e55",
  "#edb50c",
  "#b8003d",
  "#5e001f",
  "#663901",
  "#585123",
  "#383838",
  "#7a7a7a",
  "#cccccc",
  "#befe48",
  "#44008c",
  "#24f49a",
  "#9a24f4",
  "#017805",
  "#d54562",
  "#1E1E24",
  "#ff5722",
  "#ffeb3b",
  "#2c7ce6",
  "#79C4F2",
  "#ab0972",
]
